<template>
  <div class="form-container">
    <div class="el-descriptions-title">供应商信息</div>
    <el-row :class="type==='1'?'order':'review'">
      <el-col :span="12">
        <span class="el-descriptions-item-label">供应商名称：</span><span
          class="el-descriptions-item-content">{{info.companyName}}</span>
      </el-col>
      <el-col :span="12">
        <span class="el-descriptions-item-label">供应商类型：</span><span
          class="el-descriptions-item-content">{{info.supplierTypeDesc}}</span>
      </el-col>
      <template v-if="type==='1'">
        <el-col :span="12">
          <span class="el-descriptions-item-label">公司名称：</span><span
            class="el-descriptions-item-content">{{info.companyName}}</span>
        </el-col>
        <el-col :span="12">
          <span class="el-descriptions-item-label">公司注册地址：</span><span
            class="el-descriptions-item-content">{{detailData.regCity}}</span>
        </el-col>
      </template>
      <el-col :span="12">
        <span class="el-descriptions-item-label">营业执照注册号：</span><span
          @click="getOssPath(detailData.businessLicenseAttachPath)"
          :class="[{'table-handle-btn':type==='0'},'el-descriptions-item-content ']">
          {{type==='1'?detailData.businessLicenseNo:'查看'}}</span>
      </el-col>
      <el-col :span="12" v-if="type==='1'">
        <span class="el-descriptions-item-label">有效期至：</span>
        <span class="el-descriptions-item-content">
            {{detailData.longTernEffectiveBNo ? '长期有效' : detailData.certificateValidityEndBNo}}</span>
      </el-col>
      <el-col :span="12">
        <span class="el-descriptions-item-label">税务登记号：</span><span
          @click="getOssPath(detailData.taxAttachPath)"
          :class="[{'table-handle-btn':type==='0'},'el-descriptions-item-content ']">
          {{type==='1'?detailData.taxId:'查看'}}</span>
      </el-col>
      <el-col :span="12" v-if="type==='1'">
        <span class="el-descriptions-item-label">有效期至：</span><span class="el-descriptions-item-content">
            {{detailData.longTernEffectiveTaxId ? '长期有效' : detailData.certificateValidityEndTaxId}}</span>
      </el-col>
      <el-col :span="12">
        <span class="el-descriptions-item-label">组织机构代码：</span><span
          @click="getOssPath(detailData.organizationAttachPath)"
          :class="[{'table-handle-btn':type==='0'},'el-descriptions-item-content ']">
         {{type==='1'?detailData.organizationCode:'查看'}}</span>
      </el-col>
      <el-col :span="12" v-if="type==='1'">
        <span class="el-descriptions-item-label">有效期至：</span>
        <span class="el-descriptions-item-content">
            {{detailData.longTernEffectiveOCode ? '长期有效' : detailData.certificateValidityEndOCode}}
          </span>
      </el-col>
      <el-col style="overflow: hidden;line-height: 0" :span="24">
        <svg style="vertical-align: top" xmlns="http://www.w3.org/2000/svg"
             width="3000" height="2" viewBox="0 0 3000 2" fill="none">
          <path d="M0 1H3000" stroke="#C5C5C5" stroke-dasharray="2 2"/>
        </svg>
      </el-col>
    </el-row>
    <div style="font-size: 14px" class="el-descriptions-title">供应商服务能力</div>
    <div v-if="type==='0'" class="tip">请于现场审核完成后对标 <span class="required">*</span> 的供应服务能力信息进行确认</div>
    <template v-if="type==='0'||['201','205','208','217','218','219'].includes(info.applyStatus)">
      <eTableList :table-data="serviceabilityTableData" :table-label="serviceabilityTableLabel" :index-show="true">
        <template #infoName="{ scope }">
          <span v-if="scope.row.infoNecessary==='1'" class="required">*</span>
          {{scope.row.infoName}}
        </template>
        <template #handle="{ scope }">
          <span class="table-handle-btn" @click="handleView(scope.row)">查看</span>
          <template v-if="!isDetails">
            <span class="table-handle-btn" @click="handle(1,scope)">确认</span>
            <span class="table-handle-btn" @click="handle(2,scope)">驳回</span>
            <span class="table-handle-btn" @click="handle(3,scope)">撤销</span>
          </template>
        </template>
      </eTableList>
      <div style="font-size: 14px;margin-top: 20px" class="el-descriptions-title">资质信息</div>
      <div v-for="(item,index) in qualificationsTableData" :key="item.qualificationCode" style="margin-bottom: 20px">
        <div style="font-size: 14px;margin-bottom:10px;font-weight: 350;" class="el-descriptions-title">
          {{item.qualificationName}}
        </div>
        <eTableList :table-data="item.certVOList" :table-label="qualificationsTableLabel" :index-show="true">
          <template #handle="{ scope }">
            <span class="table-handle-btn" @click="handleView(scope.row)">查看</span>
            <template v-if="!isDetails">
              <span class="table-handle-btn" @click="handle(1,scope,index)">确认</span>
              <span class="table-handle-btn" @click="handle(2,scope,index)">驳回</span>
              <span class="table-handle-btn" @click="handle(3,scope,index)">撤销</span>
            </template>
          </template>
        </eTableList>
      </div>
    </template>
    <div v-if="type==='0'" style="margin-top: 20px" class="table-handle-btn" @click="downloadFile">
      一键下载审核资料&nbsp;&nbsp;>
    </div>
    <viewer-image ref="viewer" :previewSrcList="[imgUrl]"/>
  </div>
</template>

<script>
  import eTableList from '@/modules/projectA/components/common/e-table-list';
  import viewerImage from '@/modules/projectA/components/common/viewer-image';
  import {
    serviceabilityTableLabel,
    qualificationsTableLabel
  } from './componentsData';
  import Api from '@/modules/projectA/api/ESorganization';

  export default {
    name: 'supplyServiceCapability',
    components: { eTableList, viewerImage },
    props: {
      // 是否是详情页面
      isDetails: {
        type: Boolean,
        default: false
      },
      // 0: 企业信息审核,1:订单详情 默认是企业信息审核
      type: {
        type: String,
        default: '0'
      },
      // 供应商类型
      supplierType: {
        type: String,
        default: ''
      },
      info: {
        type: Object,
        default: () => {
          return {};
        }
      }
    },
    data() {
      return {
        tableData: [],
        serviceabilityTableData: [],
        qualificationsTableData: [],
        detailData: {},
        imgUrl: ''
      };
    },
    computed: {
      serviceabilityTableLabel() {
        return [...serviceabilityTableLabel, {
          label: '操作',
          align: 'center',
          width: this.isDetails ? 100 : 160,
          slot: 'handle'
        }];
      },
      qualificationsTableLabel() {
        return [...qualificationsTableLabel, {
          label: '操作',
          align: 'center',
          width: this.isDetails ? 100 : 160,
          slot: 'handle'
        }];
      }
    },
    created() {
      Api.queryStandardizedQualificationInfo({ applyId: this.$route.query.applyId })
        .then(res => {
          if (res.code === '200') {
            res.data.forEach(item => {
              switch (item.moduleType) {
                case '1':
                  this.qualificationsTableData = item.qualificationVOList;
                  break;
                case '2':
                  this.serviceabilityTableData = item.infoVOList;
                  break;
                default:
                  break;
              }
            });
          }
        });
      // 三证信息
      Api.queryCompanyThreeEvidenceInfo({
        applyId: this.$route.query.applyId
      }).then(res => {
        if (res.code === '200') {
          this.detailData = {
            ...res.data,
            certificateValidityEndBNo: res.data.certificateValidityEndBNo?.substr(0, 10),
            certificateValidityEndTaxId: res.data.certificateValidityEndTaxId?.substr(0, 10),
            certificateValidityEndOCode: res.data.certificateValidityEndOCode?.substr(0, 10)
          };
        }
      });
    },
    methods: {
      /**
       * 一键下载
       */
      downloadFile() {
        Api.downLoadGSNQualificationFiles({
          applyId: this.$route.query.applyId
        }).then(res => {
          if (res.code === '200') {
            window.open(res.data.gsnAbsolutePathUrl);
          }
        });
      },
      /**
       * 查看
       * @param data
       */
      async handleView(data) {
        let res = await Api.getGSNAbsolutePathUrl({ gsnRelativePathUrl: data.certRelativePathUrl || data.infoRelativePathUrl });
        // gsnFileType文件类型  1:图片 2:文件
        if (res.code === '200') {
          if (res.data?.gsnAbsolutePathUrl) {
            window.open(res.data.gsnAbsolutePathUrl);
          } else {
            this.$message.warning('文件不存在');
          }
        }
      },
      /**
       * 操作
       * @param type 0:查看 1:确认 2:驳回 3:撤销
       * @param data
       * @param index 如果是资质信息会有
       */
      handle(type, data, index) {
        try {
          // 资质信息
          if (typeof index !== 'undefined') {
            this.$set(this.qualificationsTableData[index].certVOList[data.$index], 'result', type);
          } else { // 供应服务能力
            this.$set(this.serviceabilityTableData[data.$index], 'result', type);
          }
          // 审核过的list
          const arr = [];
          // 驳回的文件名
          const reason = [];
          // 资质信息
          this.qualificationsTableData.forEach(item => {
            item.certVOList.forEach(item2 => {
              if ([1, 2].includes(item2.result)) {
                arr.push({
                  applyCertificateId: item2.certId,
                  applyStatus: item2.result,
                  applyType: this.supplierType
                });
                if (item2.result === 2) {
                  reason.push(item2.certName);
                }
              }
            });
          });
          // 供应服务能力
          this.serviceabilityTableData.forEach(item => {
            if ([1, 2].includes(item.result)) {
              arr.push({
                applyCertificateId: item.infoId,
                applyStatus: item.result,
                applyType: this.supplierType,
                certificateNecessary: item.infoNecessary
              });
              if (item.result === 2) {
                reason.push(item.infoName);
              }
            }
          });
          this.$emit('audit', arr, reason.join('、'));
        } catch (e) {
          console.log(e);
        }
      },
      /**
       * 验证必须审核的附件是否都审核
       * @returns {boolean}
       */
      verify() {
        const flat = this.serviceabilityTableData.filter(item => item.infoNecessary === '1' && ![1, 2].includes(item.result)).length > 0;
        if (flat) {
          this.$message.warning('请于现场审核完成后对标 * 的供应服务能力信息进行确认');
        }
        return !flat;
      },
      /**
       * 查看三证信息
       * @param ossPrivateFilePath
       * @returns {Promise<void>}
       */
      async getOssPath(ossPrivateFilePath) {
        if (this.type === '1') {
          return;
        }
        if (!ossPrivateFilePath) {
          this.$message.warning('文件不存在');
        } else {
          let res = await Api.getOssPath({ ossPrivateFilePath });
          if (res.code === '200') {
            this.imgUrl = res.data;
            this.$refs.viewer.show();
          }
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import "common";

  .el-row {
    .el-col:nth-child(2n+1) {
      .el-descriptions-item-label {
        width: 112px;
      }
    }
  }

  .order.el-row {
    .el-col:nth-child(2n) {
      .el-descriptions-item-label {
        width: 98px;
      }
    }
  }

  .review.el-row {
    .el-col:nth-child(2n) {
      .el-descriptions-item-label {
        width: 84px;
      }
    }
  }
</style>